// @flow

import React, { PureComponent } from 'react';
import { Spinner } from 'component-library';
import Moment from 'moment';
import NewsIcon from '../../UI/NewsIcon';
import './PlayerProps.css';

// header

type Props = {
    sortPlayers: string,
    sortDirection: string,
    isPast: boolean,
    sport: string,
    positionFilter: ?string,
    statFilter: ?string,
    bookFilter: ?string,
    resultFilter: ?string,
    playerFilter: ?string,
    teamFilter: ?string,
    playerProps: { [key: string]: any },
    addDefaultSrc: Function,
    togglePlayerCard: Function,
    handlePlayerSort: Function
};

class PlayerProps extends PureComponent<Props> {
    filterPlayers = (playerProps: { [key: string]: any }, filters: Array<any>) => {
        let filteredPlayers = playerProps;

        filters.map(function(filter) {
            if (filter.label === 'position' && filter.values.length > 0) {
                filteredPlayers = filteredPlayers.filter(function(player) {
                    return filter.values.indexOf(player.position) > -1;
                });
            }
            if (filter.label === 'stat' && filter.values.length > 0) {
                filteredPlayers = filteredPlayers.filter(function(player) {
                    return filter.values.indexOf(player.stat) > -1;
                });
            }
            if (filter.label === 'book' && filter.values.length > 0) {
                filteredPlayers = filteredPlayers.filter(function(player) {
                    return filter.values.indexOf(player.book) > -1;
                });
            }
            if (filter.label === 'result' && filter.values.length > 0) {
                filteredPlayers = filteredPlayers.filter(function(player) {
                    return filter.values.indexOf(player.bet_result) > -1;
                });
            }
            if (filter.label === 'player' && filter.values.length > 0) {
                filteredPlayers = filteredPlayers.filter(function(player) {
                    return player.player_name.toLowerCase().includes(filter.values[0].toLowerCase());
                });
            }
            if (filter.label === 'team' && filter.values.length > 0) {
                filteredPlayers = filteredPlayers.filter(function(player) {
                    return filter.values.indexOf(player.team_id) > -1;
                });
            }
            return null;
        });
        return filteredPlayers;
    };

    sortPlayers = (playerProps: { [key: string]: any }, sort: string, direction: string) => {
        playerProps.sort(function(a, b) {
            let dir = -1;
            if (direction === 'asc') {
                dir = 1;
            }

            if (sort === 'Time') {
                if (a.event_date_time > b.event_date_time) {
                    return -1 * dir;
                } else if (a.event_date_time < b.event_date_time) {
                    return 1 * dir;
                }
            }
            if (sort === 'Team') {
                if (a.team > b.team) {
                    return -1 * dir;
                } else if (a.team < b.team) {
                    return 1 * dir;
                }
            }
            if (sort === 'OppTeam') {
                if (a.opp_team > b.opp_team) {
                    return -1 * dir;
                } else if (a.opp_team < b.opp_team) {
                    return 1 * dir;
                }
            }
            if (sort === 'Pos') {
                if (a.position > b.position) {
                    return 1 * dir;
                } else if (a.position < b.position) {
                    return -1 * dir;
                }
            }
            if (sort === 'Player') {
                if (a.PlayerName > b.PlayerName) {
                    return 1 * dir;
                } else if (a.PlayerName < b.PlayerName) {
                    return -1 * dir;
                }
            }
            if (sort === 'Stat') {
                if (a.stat > b.stat) {
                    return 1 * dir;
                } else if (a.stat < b.stat) {
                    return -1 * dir;
                }
            }
            if (sort === 'LabsProj') {
                if (a.labs_proj > b.labs_proj) {
                    return 1 * dir;
                } else if (a.labs_proj < b.labs_proj) {
                    return -1 * dir;
                }
            }
            if (sort === 'Book') {
                if (a.book > b.book) {
                    return 1 * dir;
                } else if (a.book < b.book) {
                    return -1 * dir;
                }
            }
            if (sort === 'BookProj') {
                if (a.book_proj > b.book_proj) {
                    return 1 * dir;
                } else if (a.book_proj < b.book_proj) {
                    return -1 * dir;
                }
            }
            if (sort === 'Side') {
                if (a.side > b.side) {
                    return 1 * dir;
                } else if (a.side < b.side) {
                    return -1 * dir;
                }
            }
            if (sort === 'BetQuality') {
                if (a.bet_quality === b.bet_quality) {
                    if (Math.abs(a.diff_pct) > Math.abs(b.diff_pct)) {
                        return 1 * dir;
                    } else if (Math.abs(a.diff_pct) < Math.abs(b.diff_pct)) {
                        return -1 * dir;
                    }
                } else {
                    if (a.bet_quality > b.bet_quality) {
                        return 1 * dir;
                    } else if (a.bet_quality < b.bet_quality) {
                        return -1 * dir;
                    }
                }
            }
            if (sort === 'Odds') {
                if (a.odds > b.odds) {
                    return 1 * dir;
                } else if (a.odds < b.odds) {
                    return -1 * dir;
                }
            }
            if (sort === 'Diff') {
                if (Math.abs(a.diff_pct) > Math.abs(b.diff_pct)) {
                    return 1 * dir;
                } else if (Math.abs(a.diff_pct) < Math.abs(b.diff_pct)) {
                    return -1 * dir;
                }
            }
            if (sort === 'Actual') {
                if (a.actual_stat_result > b.actual_stat_result) {
                    return 1 * dir;
                } else if (a.actual_stat_result < b.actual_stat_result) {
                    return -1 * dir;
                }
            }
            if (sort === 'Result') {
                if (a.bet_result > b.bet_result) {
                    return 1 * dir;
                } else if (a.bet_result < b.bet_result) {
                    return -1 * dir;
                }
            }
            if (a.player_name < b.player_name) {
                return 1 * dir;
            } else if (a.player_name > b.player_name) {
                return -1 * dir;
            }
            return 0;
        });
    };

    render() {
        let playerPropsData;
        const addDefaultSrc = this.props.addDefaultSrc;
        const togglePlayerCard = this.props.togglePlayerCard;
        const isPast = this.props.isPast;
        const sport = this.props.sport;
        const filters = [
            { label: 'position', values: this.props.positionFilter },
            { label: 'stat', values: this.props.statFilter },
            { label: 'book', values: this.props.bookFilter },
            { label: 'result', values: this.props.resultFilter },
            { label: 'player', values: this.props.playerFilter },
            { label: 'team', values: this.props.teamFilter }
        ];

        if (this.props.playerProps.playersLoading === false) {
            if (this.props.playerProps.results.length > 0 && filters.length > 0) {
                this.sortPlayers(this.props.playerProps.results, this.props.sortPlayers, this.props.sortDirection);
                const filteredPlayers = this.filterPlayers(this.props.playerProps.results, filters);

                playerPropsData = filteredPlayers.map(function(playerProps) {
                    const rowClass = '';
                    let newsIcon = '';
                    const showPlayer = true;
                    let isPastResult = true;
                    if (Moment(playerProps.event_date_time) < Moment()) {
                        isPastResult = false;
                    }

                    if (playerProps.has_news !== null && playerProps.has_news === 'Y') {
                        newsIcon = <NewsIcon />;
                    }
                    if (showPlayer === true) {
                        return (
                            <div key={playerProps.id} className={'display-table-row player-row'}>
                                <div className={'display-table-cell first-col'} style={{ width: '100px' }}>
                                    {Moment(playerProps.event_date_time)
                                        .format('M/D h:mm A')}{' '}
                                    ET
                                </div>
                                <div className={'display-table-cell right'} style={{ width: '40px' }}>
                                    {playerProps.team} &nbsp;
                                </div>
                                <div className={'display-table-cell left'} style={{ width: '50px' }}>
                                    {playerProps.event_side === 'Home'
                                        ? 'vs '
                                        : playerProps.event_side === 'Away'
                                            ? '@ '
                                            : ''}
                                    {playerProps.opp_team}
                                </div>
                                <div
                                    className={'display-table-cell player-cell hover ' + rowClass}
                                    style={{ width: '140px' }}
                                    onClick={e => togglePlayerCard(playerProps, e)}
                                >
                                    <div className={'inline-div'}>
                                        <img
                                            src={
                                                'https://dpyukwfjby8ty.cloudfront.net/images/' +
                                                playerProps.player_id +
                                                '.jpg'
                                            }
                                            onError={addDefaultSrc}
                                            className={'player-headshot-circle'}
                                            style={{ width: '28px', height: '28px', marginRight: '5px' }}
                                            alt={playerProps.player_name}
                                        />
                                    </div>
                                    <div className={'inline-div'}>{playerProps.player_name}</div>
                                    {newsIcon}
                                </div>
                                {sport === 'mlb' ? null : (
                                    <div className={'display-table-cell center'} style={{ width: '40px' }}>
                                        {playerProps.position}
                                    </div>
                                )}
                                <div className={'display-table-cell center'} style={{ width: '75px' }}>
                                    {playerProps.stat.replace('Pitcher', '')}
                                </div>
                                <div className={'display-table-cell center'} style={{ width: '80px' }}>
                                    {playerProps.labs_proj} {playerProps.stat_units}
                                </div>
                                <div className={'display-table-cell center'} style={{ display: 'none', width: '75px' }}>
                                    {playerProps.book}
                                </div>
                                <div className={'display-table-cell center'} style={{ width: '100px' }}>
                                    {playerProps.book_proj} {playerProps.stat_units}
                                </div>
                                <div className={'display-table-cell center'} style={{ width: '50px' }}>
                                    {playerProps.side}
                                </div>
                                <div
                                    className={'display-table-cell center pct_' + playerProps.bet_quality + '0'}
                                    style={{ width: '60px' }}
                                >
                                    {playerProps.bet_quality}
                                </div>
                                <div className={'display-table-cell center'} style={{ width: '80px' }}>
                                    {playerProps.odds_value} {playerProps.stat_units} {playerProps.odds >= 0 ? '+' : ''}
                                    {playerProps.odds}
                                </div>
                                <div className={'display-table-cell center'} style={{ width: '90px' }}>
                                    {playerProps.diff} {playerProps.stat_units} ({playerProps.diff_pct}
                                    %)
                                </div>
                                {isPast === true ? (
                                    isPastResult === false ? (
                                        <div className={'display-table-cell center'} style={{ width: '80px' }}>
                                            {playerProps.actual_stat_result} {playerProps.stat_units}
                                        </div>
                                    ) : (
                                        <div className={'display-table-cell center'} style={{ width: '80px' }}>
                                            -
                                        </div>
                                    )
                                ) : null}
                                {isPast === true ? (
                                    isPastResult === false ? (
                                        <div className={'display-table-cell center'} style={{ width: '80px' }}>
                                            <div className={'bet-result-number'}>{playerProps.bet_result}</div>
                                            <div className={'bet-result-' + playerProps.bet_result}>&nbsp;</div>
                                        </div>
                                    ) : (
                                        <div className={'display-table-cell center'} style={{ width: '80px' }}>
                                            -
                                        </div>
                                    )
                                ) : null}
                            </div>
                        );
                    }
                    return null;
                });
                playerPropsData = (
                    <div className={'display-table'}>
                        <div className={'display-table-row header-row'}>
                            <div
                                className={'display-table-cell row-header hover first-col'}
                                onClick={() => this.props.handlePlayerSort('Time')}
                            >
                                <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                    Time
                                </div>
                                <div
                                    className={
                                        this.props.sortPlayers === 'Time' && this.props.sortDirection === 'desc'
                                            ? 'inline-div arrow-down'
                                            : 'inline-div'
                                    }
                                />
                                <div
                                    className={
                                        this.props.sortPlayers === 'Time' && this.props.sortDirection === 'asc'
                                            ? 'inline-div arrow-up'
                                            : 'inline-div'
                                    }
                                />
                            </div>
                            <div
                                className={'display-table-cell right row-header hover'}
                                onClick={() => this.props.handlePlayerSort('Team')}
                            >
                                <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                    Team
                                </div>
                                <div
                                    className={
                                        this.props.sortPlayers === 'Team' && this.props.sortDirection === 'desc'
                                            ? 'inline-div arrow-down'
                                            : 'inline-div'
                                    }
                                />
                                <div
                                    className={
                                        this.props.sortPlayers === 'Team' && this.props.sortDirection === 'asc'
                                            ? 'inline-div arrow-up'
                                            : 'inline-div'
                                    }
                                />
                            </div>
                            <div
                                className={'display-table-cell center row-header hover'}
                                onClick={() => this.props.handlePlayerSort('OppTeam')}
                            >
                                <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                    Opp
                                </div>
                                <div
                                    className={
                                        this.props.sortPlayers === 'OppTeam' && this.props.sortDirection === 'desc'
                                            ? 'inline-div arrow-down'
                                            : 'inline-div'
                                    }
                                />
                                <div
                                    className={
                                        this.props.sortPlayers === 'OppTeam' && this.props.sortDirection === 'asc'
                                            ? 'inline-div arrow-up'
                                            : 'inline-div'
                                    }
                                />
                            </div>
                            <div
                                className={'display-table-cell row-header hover'}
                                onClick={() => this.props.handlePlayerSort('Player')}
                            >
                                <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                    Player
                                </div>
                                <div
                                    className={
                                        this.props.sortPlayers === 'Player' && this.props.sortDirection === 'desc'
                                            ? 'inline-div arrow-down'
                                            : 'inline-div'
                                    }
                                />
                                <div
                                    className={
                                        this.props.sortPlayers === 'Player' && this.props.sortDirection === 'asc'
                                            ? 'inline-div arrow-up'
                                            : 'inline-div'
                                    }
                                />
                            </div>
                            {sport === 'mlb' ? null : (
                                <div
                                    className={'display-table-cell center row-header hover'}
                                    onClick={() => this.props.handlePlayerSort('Pos')}
                                >
                                    <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                        Pos
                                    </div>
                                    <div
                                        className={
                                            this.props.sortPlayers === 'Pos' && this.props.sortDirection === 'desc'
                                                ? 'inline-div arrow-down'
                                                : 'inline-div'
                                        }
                                    />
                                    <div
                                        className={
                                            this.props.sortPlayers === 'Pos' && this.props.sortDirection === 'asc'
                                                ? 'inline-div arrow-up'
                                                : 'inline-div'
                                        }
                                    />
                                </div>
                            )}
                            <div
                                className={'display-table-cell center row-header hover'}
                                onClick={() => this.props.handlePlayerSort('Stat')}
                            >
                                <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                    Stat
                                </div>
                                <div
                                    className={
                                        this.props.sortPlayers === 'Stat' && this.props.sortDirection === 'desc'
                                            ? 'inline-div arrow-down'
                                            : 'inline-div'
                                    }
                                />
                                <div
                                    className={
                                        this.props.sortPlayers === 'Stat' && this.props.sortDirection === 'asc'
                                            ? 'inline-div arrow-up'
                                            : 'inline-div'
                                    }
                                />
                            </div>
                            <div
                                className={'display-table-cell center row-header hover'}
                                onClick={() => this.props.handlePlayerSort('LabsProj')}
                            >
                                <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                    Our Proj
                                </div>
                                <div
                                    className={
                                        this.props.sortPlayers === 'LabsProj' && this.props.sortDirection === 'desc'
                                            ? 'inline-div arrow-down'
                                            : 'inline-div'
                                    }
                                />
                                <div
                                    className={
                                        this.props.sortPlayers === 'LabsProj' && this.props.sortDirection === 'asc'
                                            ? 'inline-div arrow-up'
                                            : 'inline-div'
                                    }
                                />
                            </div>
                            <div
                                style={{display:'none'}}
                                className={'display-table-cell center row-header hover'}
                                onClick={() => this.props.handlePlayerSort('Book')}
                            >
                                <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                    Sportsbook
                                </div>
                                <div
                                    className={
                                        this.props.sortPlayers === 'Book' && this.props.sortDirection === 'desc'
                                            ? 'inline-div arrow-down'
                                            : 'inline-div'
                                    }
                                />
                                <div
                                    className={
                                        this.props.sortPlayers === 'Book' && this.props.sortDirection === 'asc'
                                            ? 'inline-div arrow-up'
                                            : 'inline-div'
                                    }
                                />
                            </div>
                            <div
                                className={'display-table-cell center row-header hover'}
                                onClick={() => this.props.handlePlayerSort('BookProj')}
                            >
                                <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                    Implied Total
                                </div>
                                <div
                                    className={
                                        this.props.sortPlayers === 'BookProj' && this.props.sortDirection === 'desc'
                                            ? 'inline-div arrow-down'
                                            : 'inline-div'
                                    }
                                />
                                <div
                                    className={
                                        this.props.sortPlayers === 'BookProj' && this.props.sortDirection === 'asc'
                                            ? 'inline-div arrow-up'
                                            : 'inline-div'
                                    }
                                />
                            </div>
                            <div
                                className={'display-table-cell center row-header hover'}
                                onClick={() => this.props.handlePlayerSort('Side')}
                            >
                                <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                    Side
                                </div>
                                <div
                                    className={
                                        this.props.sortPlayers === 'Side' && this.props.sortDirection === 'desc'
                                            ? 'inline-div arrow-down'
                                            : 'inline-div'
                                    }
                                />
                                <div
                                    className={
                                        this.props.sortPlayers === 'Side' && this.props.sortDirection === 'asc'
                                            ? 'inline-div arrow-up'
                                            : 'inline-div'
                                    }
                                />
                            </div>
                            <div
                                className={'display-table-cell center row-header hover'}
                                onClick={() => this.props.handlePlayerSort('BetQuality')}
                            >
                                <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                    Bet Quality
                                </div>
                                <div
                                    className={
                                        this.props.sortPlayers === 'BetQuality' && this.props.sortDirection === 'desc'
                                            ? 'inline-div arrow-down'
                                            : 'inline-div'
                                    }
                                />
                                <div
                                    className={
                                        this.props.sortPlayers === 'BetQuality' && this.props.sortDirection === 'asc'
                                            ? 'inline-div arrow-up'
                                            : 'inline-div'
                                    }
                                />
                            </div>
                            <div
                                className={'display-table-cell center row-header hover'}
                                onClick={() => this.props.handlePlayerSort('Odds')}
                            >
                                <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                    Odds
                                </div>
                                <div
                                    className={
                                        this.props.sortPlayers === 'Odds' && this.props.sortDirection === 'desc'
                                            ? 'inline-div arrow-down'
                                            : 'inline-div'
                                    }
                                />
                                <div
                                    className={
                                        this.props.sortPlayers === 'Odds' && this.props.sortDirection === 'asc'
                                            ? 'inline-div arrow-up'
                                            : 'inline-div'
                                    }
                                />
                            </div>
                            <div
                                className={'display-table-cell center row-header hover'}
                                onClick={() => this.props.handlePlayerSort('Diff')}
                            >
                                <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                    Difference
                                </div>
                                <div
                                    className={
                                        this.props.sortPlayers === 'Diff' && this.props.sortDirection === 'desc'
                                            ? 'inline-div arrow-down'
                                            : 'inline-div'
                                    }
                                />
                                <div
                                    className={
                                        this.props.sortPlayers === 'Diff' && this.props.sortDirection === 'asc'
                                            ? 'inline-div arrow-up'
                                            : 'inline-div'
                                    }
                                />
                            </div>
                            {isPast === true ? (
                                <div
                                    className={'display-table-cell center row-header hover'}
                                    onClick={() => this.props.handlePlayerSort('Actual')}
                                >
                                    <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                        Actual Value
                                    </div>
                                    <div
                                        className={
                                            this.props.sortPlayers === 'Actual' && this.props.sortDirection === 'desc'
                                                ? 'inline-div arrow-down'
                                                : 'inline-div'
                                        }
                                    />
                                    <div
                                        className={
                                            this.props.sortPlayers === 'Actual' && this.props.sortDirection === 'asc'
                                                ? 'inline-div arrow-up'
                                                : 'inline-div'
                                        }
                                    />
                                </div>
                            ) : null}
                            {isPast === true ? (
                                <div
                                    className={'display-table-cell center row-header hover'}
                                    onClick={() => this.props.handlePlayerSort('Result')}
                                >
                                    <div className={'inline-div'} style={{ paddingRight: '3px' }}>
                                        Bet Result
                                    </div>
                                    <div
                                        className={
                                            this.props.sortPlayers === 'Result' && this.props.sortDirection === 'desc'
                                                ? 'inline-div arrow-down'
                                                : 'inline-div'
                                        }
                                    />
                                    <div
                                        className={
                                            this.props.sortPlayers === 'Result' && this.props.sortDirection === 'asc'
                                                ? 'inline-div arrow-up'
                                                : 'inline-div'
                                        }
                                    />
                                </div>
                            ) : null}
                        </div>
                        {playerPropsData}
                    </div>
                );
            }
        } else {
            playerPropsData = <Spinner />;
        }

        const display = !!playerPropsData ? (
            <div className={'display-table props-table'}>{playerPropsData}</div>
        ) : (
            <div className={'center'}>
                There are no available props. Check back closer to game time, when most prop bets are offered.
            </div>
        );

        return display;
    }
}

export default PlayerProps;



// WEBPACK FOOTER //
// ./src/components/Main/PlayerProps/PlayerProps.js